module.exports = __webpack_public_path__ + "static/media/wave-line-horizontal.66b5002a.svg";